import { getFunctions, httpsCallable } from "firebase/functions";
import { construirHorarioPorEnfermero } from "./horarios";

const SEMANAS_DEFECTO = 12;

async function listarDisponibilidad(uids, semanas = SEMANAS_DEFECTO) {
  if (!uids.length) return {};
  const funciones = getFunctions();
  const callable = httpsCallable(funciones, "listarDisponibilidadCallable");
  const respuesta = await callable({
    uids,
    semanas,
    soloFuturos: false,
  });
  return respuesta?.data?.porEnfermero || {};
}

export async function obtenerHorarioBaseDesdeFirestore(enfermeros = [], opciones = {}) {
  const semanas = Number.isFinite(opciones.semanas) ? opciones.semanas : SEMANAS_DEFECTO;
  const bloques = [];
  const ids = enfermeros.map((enfermero) => enfermero?.id).filter(Boolean);
  if (!ids.length) {
    return construirHorarioPorEnfermero([]);
  }

  try {
    const respuestaPorEnfermero = await listarDisponibilidad(ids, semanas);
    Object.entries(respuestaPorEnfermero).forEach(([uid, lista]) => {
      (lista || []).forEach((bloque) => {
        if (
          bloque?.start?.includes("T") &&
          bloque?.end?.includes("T") &&
          typeof uid === "string"
        ) {
          bloques.push({
            ...bloque,
            id: bloque.id,
            enfermeroId: uid,
          });
        } else {
          console.warn(`⚠️ Bloque inválido ignorado para esteticista ${uid}:`, bloque);
        }
      });
    });
  } catch (error) {
    console.error("❌ Error obteniendo disponibilidad normalizada:", error);
    return construirHorarioPorEnfermero([]);
  }

  // 🧠 Log para depuración
  console.log("🧱 Bloques expandidos por esteticista:");
  console.table(
    bloques.map((b) => ({
      Esteticista: b.enfermeroId,
      FechaInicio: b.start,
      FechaFin: b.end,
    }))
  );

  // 🔄 Armar la estructura final por enfermero/día
  const estructuraFinal = construirHorarioPorEnfermero(bloques);
  return {
    ...estructuraFinal,
    bloques,
  };
}
